import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section id="inicio" className="relative min-h-[90vh] flex items-center justify-center pt-14 overflow-hidden" data-id="element-142">
      <motion.div className="absolute inset-0 z-0" initial={{
      scale: 1.15,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 1.8,
      ease: 'easeOut'
    }} data-id="element-143">
        <motion.img src="https://cdn.magicpatterns.com/uploads/wxb9hfYp8tW2YRmeYVAeCP/heylloyd-image-1774743262443.png" alt="Construction Professional" className="w-full h-full object-cover object-center" animate={{
        scale: [1, 1.05, 1]
      }} transition={{
        duration: 20,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-144" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-bg-dark/50 via-brand-bg-dark/20 to-transparent" data-id="element-145"></div>
        <div className="absolute inset-0 bg-black/10" data-id="element-146"></div>
      </motion.div>
    </section>;
}